"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Row = exports.Head = exports.Cell = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CellWrapper = _styledComponents.default.div.withConfig({
  displayName: "Table__CellWrapper",
  componentId: "design-system__sc-149xiik-0"
})(["flex-grow:1;padding:", ";display:flex;align-items:center;min-height:3.5rem;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";border-bottom:1px solid ", ";background-color:", ";&:nth-child(1){padding-left:1rem;}& > span{display:flex;align-items:center;}& > span > div{margin-right:", ";}&.iconleft div{margin-right:", ";}&.iconright{justify-content:space-between;}& + div{border-left-width:0;}"], _BaseTheme.default.distance.tiny, _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.type.weight.regular, _BaseTheme.default.type.lineHeight.regular, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.white, _BaseTheme.default.distance.normal, _BaseTheme.default.distance.normal);

const Cell = _ref => {
  let {
    className,
    children,
    iconLeft,
    iconRight,
    size
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(CellWrapper, {
    className: "".concat(className, " ").concat(iconLeft ? 'iconleft' : '', " ").concat(iconRight ? 'iconright' : ''),
    style: {
      width: "".concat(size, "%")
    }
  }, iconLeft || '', /*#__PURE__*/_react.default.createElement("span", null, children), iconRight || '');
};

exports.Cell = Cell;
const Head = (0, _styledComponents.default)(Cell).withConfig({
  displayName: "Table__Head",
  componentId: "design-system__sc-149xiik-1"
})(["font-family:", ";border-bottom:1px solid ", ";color:", ";height:2.5rem;"], _BaseTheme.default.type.family.system, _BaseTheme.default.colors.lightgray, _BaseTheme.default.colors.textgray);
exports.Head = Head;

const RowWrapper = _styledComponents.default.div.withConfig({
  displayName: "Table__RowWrapper",
  componentId: "design-system__sc-149xiik-2"
})(["display:flex;align-items:stretch;flex-grow:1;"]);

const Row = _ref2 => {
  let {
    className,
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(RowWrapper, {
    className: className
  }, children);
};

exports.Row = Row;

const TableComponent = _ref3 => {
  let {
    className,
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
};

const Table = (0, _styledComponents.default)(TableComponent).withConfig({
  displayName: "Table",
  componentId: "design-system__sc-149xiik-3"
})(["width:100%;"]);
Cell.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  iconLeft: _propTypes.default.element,
  iconRight: _propTypes.default.element,
  size: _propTypes.default.number.isRequired
};
Cell.defaultProps = {
  className: '',
  children: null,
  iconLeft: null,
  iconRight: null
};
Row.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
Row.defaultProps = {
  className: ''
};
TableComponent.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
TableComponent.defaultProps = {
  className: ''
};
Table.Row = Row;
Table.Head = Head;
Table.Cell = Cell;
var _default = Table;
exports.default = _default;